import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { LifecycleStage } from '@vendasta/account-group';
import { RuleInterface } from '@vendasta/automata';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AutomationReplacementChipsComponent } from '../../../../../common/components/automation-replacement-chips/automation-replacement-chips.component';
import { StaticSelectorService } from '../../../../../data-services/static-selector.service';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { LifecycleFormDataFormat } from '../set-account-lifecycle-stage.service';

@Component({
  selector: 'automata-set-account-lifecycle-stage-panel',
  templateUrl: './set-account-lifecycle-stage-panel.component.html',
  styleUrls: ['./set-account-lifecycle-stage-panel.component.scss'],
  providers: [StaticSelectorService],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationReplacementChipsComponent,
  ],
})
export class SetAccountLifecycleStagePanelComponent extends CommonActionPanelComponent implements OnInit {
  lifecycleOptions = new Map<number, string>([
    [
      LifecycleStage.LIFECYCLE_STAGE_LEAD,
      this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.LEAD'),
    ],
    [
      LifecycleStage.LIFECYCLE_STAGE_PROSPECT,
      this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.PROSPECT'),
    ],
    [
      LifecycleStage.LIFECYCLE_STAGE_CUSTOMER,
      this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.SET_ACCOUNT_LIFECYCLE_STAGE.LIFECYCLE_STAGES.CUSTOMER'),
    ],
  ]);

  lifecycleStageControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
  lifecycleStageSelectorService = new StaticSelectorService<number>(this.lifecycleOptions, this.translateService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    const jsonData = this.step ? JSON.parse(this.step.data || '') : {};
    this.lifecycleStageControl.setValue(jsonData.lifecycle_stage);
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): LifecycleFormDataFormat {
    const jsonData = this.step ? JSON.parse(this.step.data || '') : {};
    if (!this.lifecycleStageControl) {
      return jsonData;
    }

    jsonData.lifecycle_stage = this.lifecycleStageControl.value;
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.lifecycleStageControl];
  }

  isFormValid(): boolean {
    return this.lifecycleStageControl.valid;
  }

  finishedLoadingSelector(): void {
    this.savingEnabled = true;
  }
}
